import { render, staticRenderFns } from "./BatchImageUpload.vue?vue&type=template&id=25f46f96&scoped=true"
import script from "./BatchImageUpload.vue?vue&type=script&lang=js"
export * from "./BatchImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f46f96",
  null
  
)

export default component.exports